
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/series/[...id]",
      function () {
        return require("private-next-pages/series/[...id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/series/[...id]"])
      });
    }
  